import { Core } from "@faire/design-tokens";
import { Upload } from "@faire/slate/icons/Upload";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { Avatar } from "@faire/web/slate-deprecated/Avatar";
import { Column } from "@faire/web/slate/Layout";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";

interface IProps {
  name: string;
  image?: IImage;
  onClick?: () => void;
  disableEditing?: boolean;
}

export const EditableAvatar: React.FC<IProps> = ({
  image,
  onClick,
  name,
  disableEditing,
}) => {
  const handleClick = disableEditing ? undefined : onClick;
  return (
    <Container>
      <AvatarWrapper onClick={handleClick} data-test-id="editable-avatar">
        <ClickableAvatar
          disablePointer={!!disableEditing}
          size="x-large"
          image={image}
          iconData={{
            position: "topRight",
            icon: disableEditing ? null : (
              <IconContainer
                data-test-id="editable-avatar-upload-icon"
                $disablePointer={!!disableEditing}
                onClick={handleClick}
              >
                <UploadIcon width="15" height="15" />
              </IconContainer>
            ),
          }}
        />
      </AvatarWrapper>
      <Spacer height="3x" />
      <TextWrapper>
        <Typography align="center" maxLines={3}>
          {name}
        </Typography>
      </TextWrapper>
    </Container>
  );
};

const Container = styled(Column)`
  max-width: 166px;
  padding-left: ${getSpacing("2x")};
  padding-right: ${getSpacing("2x")};
`;

const AvatarWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
`;

const TextWrapper = styled.div`
  max-width: 140px;
`;

const UploadIcon = styled(Upload)`
  margin: auto;
`;

const ClickableAvatar = styled(Avatar)<{ disablePointer: boolean }>`
  cursor: ${({ disablePointer }) => (disablePointer ? "default" : "pointer")};
  border-left: 1px solid ${Core.surface.subdued};
  border-bottom: 1px solid ${Core.surface.subdued};
  border-top: 1px solid ${Core.surface.subdued};
`;

const IconContainer = styled.div<{ $disablePointer: boolean }>`
  background-color: ${Core.surface.subdued};
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  cursor: ${({ $disablePointer }) => ($disablePointer ? "default" : "pointer")};
`;
